import { render, staticRenderFns } from "./ProjectsAdd.vue?vue&type=template&id=00ff651a&"
import script from "./ProjectsAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports